<template>
    <div class="insert-plate">
      <h3>PER INIZIARE: INSERISCI TARGA</h3>
      <p>{{ quotationMessage }}</p>
      <div class="license-plate">
        <form action="/allestimenti" method="POST" @submit="handleSubmit" ref="plateForm">
          <input type="hidden" name="_token" :value="csrfToken" />
          <div class="license-container">
            <div class="left-plate">
              <svg
                class="desktop-left-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="82"
                height="141"
                viewBox="0 0 82 141"
              >
                <path
                  id="Rettangolo_left"
                  data-name="Rettangolo-left"
                  d="M14,0H82a0,0,0,0,1,0,0V141a0,0,0,0,1,0,0H14A14,14,0,0,1,0,127V14A14,14,0,0,1,14,0Z"
                  fill="#d9d9d9"
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="80" viewBox="0 0 65 70">
                  <g id="stelle" transform="translate(10 18)">
                    <path
                      id="Tracciato_76"
                      data-name="Tracciato 76"
                      d="M108.517,0l-.576,1.747-1.84.009,1.484,1.088L107.024,4.6l1.493-1.074L110.01,4.6l-.561-1.752,1.484-1.088-1.84-.009Z"
                      transform="translate(-88.399)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_77"
                      data-name="Tracciato 77"
                      d="M56.617,14.4l.576,1.747,1.84.008L57.55,17.241l.56,1.752-1.493-1.074-1.493,1.074.56-1.752L54.2,16.152l1.84-.008Z"
                      transform="translate(-45.158 -11.995)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_78"
                      data-name="Tracciato 78"
                      d="M17.953,51.23l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074L16.46,55.826l.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-12.945 -42.683)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_79"
                      data-name="Tracciato 79"
                      d="M1.84,107.849,0,107.857l1.483,1.088L.923,110.7l1.493-1.075L3.909,110.7l-.561-1.752,1.483-1.088-1.84-.008L2.416,106.1Z"
                      transform="translate(0 -88.4)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_80"
                      data-name="Tracciato 80"
                      d="M19.784,156.861l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.075-1.493,1.075.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-14.47 -130.691)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_81"
                      data-name="Tracciato 81"
                      d="M54.787,193.695l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-43.633 -161.379)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_82"
                      data-name="Tracciato 82"
                      d="M107.941,213.95l-1.84.008,1.484,1.088-.561,1.752,1.493-1.075,1.493,1.075-.561-1.752,1.484-1.088-1.84-.008-.577-1.747Z"
                      transform="translate(-88.399 -176.799)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_83"
                      data-name="Tracciato 83"
                      d="M162.248,193.695l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-133.166 -161.379)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_84"
                      data-name="Tracciato 84"
                      d="M197.251,156.861l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.075-1.493,1.075.561-1.752-1.484-1.088,1.84-.008Z"
                      transform="translate(-162.329 -130.691)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_85"
                      data-name="Tracciato 85"
                      d="M214.042,107.849l-1.84.008,1.483,1.088-.56,1.752,1.493-1.075,1.493,1.075-.561-1.752,1.483-1.088-1.84-.008-.576-1.747Z"
                      transform="translate(-176.799 -88.4)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_86"
                      data-name="Tracciato 86"
                      d="M199.081,51.23l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-163.854 -42.683)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_87"
                      data-name="Tracciato 87"
                      d="M160.418,14.4l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752L158,16.152l1.84-.008Z"
                      transform="translate(-131.641 -11.995)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="200" viewBox="0 0 50 80">
                  <text
                    id="I"
                    transform="translate(40 65)"
                    fill="#fff"
                    font-size="50"
                    font-family="Montserrat-Regular, Montserrat"
                  >
                    <tspan x="-7" y="0">I</tspan>
                  </text>
                </svg>
              </svg>
              <svg
                class="mobile-left-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="75"
                viewBox="0 0 100 165"
              >
                <path
                  id="Rettangolo_left_mobile"
                  data-name="Rettangolo-left"
                  d="M14,0H82a0,0,0,0,1,0,0V141a0,0,0,0,1,0,0H14A14,14,0,0,1,0,127V14A14,14,0,0,1,14,0Z"
                  fill="#d9d9d9"
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="80" viewBox="0 0 65 70">
                  <g id="stelle" transform="translate(10 18)">
                    <path
                      id="Tracciato_76"
                      data-name="Tracciato 76"
                      d="M108.517,0l-.576,1.747-1.84.009,1.484,1.088L107.024,4.6l1.493-1.074L110.01,4.6l-.561-1.752,1.484-1.088-1.84-.009Z"
                      transform="translate(-88.399)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_77"
                      data-name="Tracciato 77"
                      d="M56.617,14.4l.576,1.747,1.84.008L57.55,17.241l.56,1.752-1.493-1.074-1.493,1.074.56-1.752L54.2,16.152l1.84-.008Z"
                      transform="translate(-45.158 -11.995)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_78"
                      data-name="Tracciato 78"
                      d="M17.953,51.23l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074L16.46,55.826l.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-12.945 -42.683)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_79"
                      data-name="Tracciato 79"
                      d="M1.84,107.849,0,107.857l1.483,1.088L.923,110.7l1.493-1.075L3.909,110.7l-.561-1.752,1.483-1.088-1.84-.008L2.416,106.1Z"
                      transform="translate(0 -88.4)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_80"
                      data-name="Tracciato 80"
                      d="M19.784,156.861l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.075-1.493,1.075.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-14.47 -130.691)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_81"
                      data-name="Tracciato 81"
                      d="M54.787,193.695l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-43.633 -161.379)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_82"
                      data-name="Tracciato 82"
                      d="M107.941,213.95l-1.84.008,1.484,1.088-.561,1.752,1.493-1.075,1.493,1.075-.561-1.752,1.484-1.088-1.84-.008-.577-1.747Z"
                      transform="translate(-88.399 -176.799)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_83"
                      data-name="Tracciato 83"
                      d="M162.248,193.695l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-133.166 -161.379)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_84"
                      data-name="Tracciato 84"
                      d="M197.251,156.861l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.075-1.493,1.075.561-1.752-1.484-1.088,1.84-.008Z"
                      transform="translate(-162.329 -130.691)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_85"
                      data-name="Tracciato 85"
                      d="M214.042,107.849l-1.84.008,1.483,1.088-.56,1.752,1.493-1.075,1.493,1.075-.561-1.752,1.483-1.088-1.84-.008-.576-1.747Z"
                      transform="translate(-176.799 -88.4)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_86"
                      data-name="Tracciato 86"
                      d="M199.081,51.23l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752-1.483-1.088,1.84-.008Z"
                      transform="translate(-163.854 -42.683)"
                      fill="#fff"
                    />
                    <path
                      id="Tracciato_87"
                      data-name="Tracciato 87"
                      d="M160.418,14.4l.576,1.747,1.84.008-1.483,1.088.56,1.752-1.493-1.074-1.493,1.074.56-1.752L158,16.152l1.84-.008Z"
                      transform="translate(-131.641 -11.995)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="200" viewBox="0 0 50 80">
                  <text
                    id="I"
                    transform="translate(40 65)"
                    fill="#fff"
                    font-size="50"
                    font-family="Montserrat-Regular, Montserrat"
                  >
                    <tspan x="-7" y="0">I</tspan>
                  </text>
                </svg>
              </svg>
            </div>
            <div id="fakeInput" class="fake-input" v-on:click="focusInput" ref="fakeInput">
              <span id="char1" class="char"></span>
              <span id="char2" class="char"></span>
              <div class="spaced"></div>
              <span id="char3" class="char"></span>
              <span id="char4" class="char"></span>
              <span id="char5" class="char"></span>
              <span id="char6" class="char"></span>
              <span id="char7" class="char"></span>
              <span
                v-show="showCursor"
                :style="{ left: cursorPosition + 'px' }"
                class="cursor"
              ></span>
            </div>
            <input
              type="text"
              name="plate"
              class="licenseplate"
              autocomplete="off"
              maxlength="7"
              v-model="licensePlate"
              v-on:focus="handleFocus"
              v-on:blur="handleBlur"
              v-on:input="handleInput"
              ref="licenseInput"
            />
            <input type="hidden" v-model="vehicle_type" name="vehicle_type" />
            <input type="hidden" v-model="quotation_type" name="quotation_type" />
            <div class="right-plate">
              <svg
                class="desktop-right-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="82"
                height="141"
                viewBox="0 0 82 141"
              >
                <path
                  id="Rettangolo_right"
                  data-name="Rettangolo-right"
                  d="M14,0H82a0,0,0,0,1,0,0V141a0,0,0,0,1,0,0H14A14,14,0,0,1,0,127V14A14,14,0,0,1,14,0Z"
                  transform="translate(82 141) rotate(180)"
                  fill="#d9d9d9"
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 68 50">
                  <circle
                    id="cerchio"
                    cx="20"
                    cy="20"
                    r="20"
                    transform="translate(20 15)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="3"
                  />
                </svg>
              </svg>
              <svg
                class="mobile-right-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="75"
                viewBox="-20 0 100 165"
              >
                <path
                  id="Rettangolo_right_mobile"
                  data-name="Rettangolo-right"
                  d="M14,0H82a0,0,0,0,1,0,0V141a0,0,0,0,1,0,0H14A14,14,0,0,1,0,127V14A14,14,0,0,1,14,0Z"
                  transform="translate(82 141) rotate(180)"
                  fill="#d9d9d9"
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 68 50">
                  <circle
                    id="cerchio"
                    cx="20"
                    cy="20"
                    r="20"
                    transform="translate(20 15)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="3"
                  />
                </svg>
              </svg>
            </div>
          </div>
          <button
            class="calc-quote"
            :class="{ disabled: loading || licensePlate.length < 7 }"
            ref="submitButton"
            :disabled="loading || licensePlate.length < 7"
            title="Calcola Quotazione"
          >
            <template v-if="!loading">Calcola quotazione</template>
            <loader v-else size="20px" />
          </button>
        </form>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios';

  export default {
    name: 'InsertPlate',
    props: {
      vehicle_type: {
        type: Number,
        required: true,
      },
      initial_plate: {
        type: String,
        default: '',
      },
      quotation_type: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        licensePlate: this.initial_plate,
        loading: false,
        showCursor: false,
        cursorPosition: 85,
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      };
    },
    computed: {
      quotationMessage() {
        switch (this.quotation_type) {
          case 'nominale':
            return 'per ottenere la Quotazione Nominale del tuo veicolo';
          case 'storica':
            return 'per ottenere la Quotazione Storica del tuo veicolo';
          case 'live-market':
            return 'per ottenere il Report Live Market del tuo veicolo';
          default:
            return 'per ottenere la Quotazione del tuo veicolo';
        }
      },
    },
    watch: {
      licensePlate(newVal) {
        if (newVal.length === 0 && !this.$refs.licenseInput === document.activeElement) {
          this.changeRectColor('#d9d9d9');
        } else {
          this.changeRectColor('#00679D');
        }
        localStorage.setItem('plate', newVal);
        this.updateFakeInput(newVal);
      },
    },
    methods: {
      handleFocus() {
        this.showCursor = true;
        this.changeRectColor('#00679D');
      },
      handleBlur() {
        this.showCursor = false;
        if (this.licensePlate.length === 0) {
          this.changeRectColor('#d9d9d9');
        }
      },
      changeRectColor(color) {
        const rettangoloLeft = document.querySelector('#Rettangolo_left');
        const rettangoloLeftMobile = document.querySelector('#Rettangolo_left_mobile');
        const rettangoloRightMobile = document.querySelector('#Rettangolo_right_mobile');
        const rettangoloRight = document.querySelector('#Rettangolo_right');
        rettangoloLeft.setAttribute('fill', color);
        rettangoloLeftMobile.setAttribute('fill', color);
        rettangoloRightMobile.setAttribute('fill', color);
        rettangoloRight.setAttribute('fill', color);
      },
      focusInput() {
        this.$refs.licenseInput.focus();
      },
      handleInput(event) {
        let value = event.target.value;
        value = this.filterInput(value, 0, 2, /[A-Za-z]/); // Lettere nei primi 2 input
        value = this.filterInput(value, 2, 5, /[0-9]/); // Numeri nei successivi 3 input
        value = this.filterInput(value, 5, 7, /[A-Za-z]/); // Lettere negli ultimi 2 input

        this.licensePlate = value;

        this.updateFakeInput(value);
        this.$refs.submitButton.classList.toggle('disabled', value.length < 7);
      },
      filterInput(value, start, end, regex) {
        return value
          .split('')
          .map((char, index) => {
            if (index >= start && index < end) {
              return regex.test(char) ? char : '';
            }
            return char;
          })
          .join('');
      },
      async handleSubmit(event) {
        event.preventDefault();

        // Verifica che la targa sia valida
        if (this.licensePlate && this.licensePlate.length === 7) {
          this.loading = true;
          try {
            const res = await axios.post('/api/check-plate', {
              plate: this.licensePlate,
            });

            if (res.data.success) {
              this.$refs.plateForm.submit();
            } else {
              window.alert('La targa inserita non è valida. Verifica e riprova.');
            }
          } catch (error) {
            window.alert(
              'Stiamo rilevando un problema nel collegamento con i servizi del Ministero dei Trasporti e di ACI per il recupero delle informazioni sulle targhe. Ti consigliamo di scegliere il veicolo da quotare utilizzando le tendine di Marca-Modello-Allestimento ed anno di immatricolazione. Ci scusiamo per il temporaneo disservizio.',
            );
          } finally {
            this.loading = false;
          }
        }
      },
      updateFakeInput(value) {
        const chars = this.$refs.fakeInput.querySelectorAll('span.char');
        const valueArray = value.split('');
        chars.forEach((span, i) => {
          span.textContent = valueArray[i] || '';
        });

        // Calcola la posizione del cursore
        const characterWidth = this.$refs.fakeInput.querySelector('span.char').offsetWidth;
        const spacedWidth = this.$refs.fakeInput.querySelector('.spaced').offsetWidth;
        let cursorPos;
        if (window.innerWidth <= 768) {
          cursorPos = value.length * characterWidth;
          if (value.length > 2) {
            cursorPos += spacedWidth;
          }
        } else {
          cursorPos = value.length * characterWidth + 10;
          if (value.length > 2) {
            cursorPos += spacedWidth;
          }
        }

        this.cursorPosition = cursorPos;
      },
      handlePageShow(event) {
        let navigationType = 'navigate';

        if (event.persisted) {
          // La pagina è stata caricata dalla cache (es. navigazione 'Indietro' o 'Avanti')
          navigationType = 'back_forward';
        } else {
          if (performance.getEntriesByType('navigation').length > 0) {
            navigationType = performance.getEntriesByType('navigation')[0].type;
          } else if (performance.navigation) {
            switch (performance.navigation.type) {
              case 0:
                navigationType = 'navigate';
                break;
              case 1:
                navigationType = 'reload';
                break;
              case 2:
                navigationType = 'back_forward';
                break;
              case 255:
                navigationType = 'reserved';
                break;
              default:
                navigationType = 'unknown';
                break;
            }
          }
        }

        if (navigationType === 'reload' || navigationType === 'back_forward') {
          // Cancella il valore della targa dal localStorage
          localStorage.removeItem('plate');
          this.licensePlate = '';
          this.updateFakeInput('');
          this.$nextTick(() => {
            this.handleBlur();
          });
        } else {
          // Recupera il valore della targa dal localStorage
          const storedPlate = localStorage.getItem('plate');

          if (storedPlate) {
            this.licensePlate = storedPlate;
            this.updateFakeInput(storedPlate);
          } else {
            this.licensePlate = '';
            this.updateFakeInput('');
          }
        }
      },
    },
    mounted() {
      this.$refs.licenseInput.style.opacity = 0;
      this.$refs.licenseInput.style.position = 'absolute';
      this.$refs.licenseInput.style.zIndex = '-1';

      window.addEventListener('pageshow', this.handlePageShow);

      this.handlePageShow({ persisted: false });
    },
    destroyed() {
      window.removeEventListener('pageshow', this.handlePageShow);
    },
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/InsertPlate.vue